import { IconButton, Tooltip } from "@mui/material"
import { useSnackbar } from "notistack"
import Iconify from "minimals-template/components/Iconify"
import { useDialog } from "lib/@hooks/useDialog"
import { updateCommentaryOverview } from "../controller/update-commentary-overview"
import { SECTION_DIALOG_TITLE_ID, ScheduleCommentarySectionDialog } from "./schedule-commentary-section-dialog"

export function ScheduleCommentaryEditOverviewButton({ overview }) {
    const { enqueueSnackbar } = useSnackbar()
    const openDialog = useDialog(
        <ScheduleCommentarySectionDialog
            heading="Edit overview"
            okCaption="Save"
            section={overview}
            showDescription={false}
        />,
        { "aria-labelledby": SECTION_DIALOG_TITLE_ID }
    )

    return (
        <Tooltip title="Edit overview">
            <IconButton
                size="small"
                color="primary"
                onClick={handleEdit}
                aria-label="Edit overview"
                data-cy="schedule-commentary-edit-overview"
            >
                <Iconify icon="mdi:pencil-outline" />
            </IconButton>
        </Tooltip>
    )

    async function handleEdit() {
        const edited = await openDialog()
        if (!edited) return
        try {
            await updateCommentaryOverview({ title: edited.title, content: edited.content })
            enqueueSnackbar("Overview saved", { variant: "success" })
        } catch (error) {
            enqueueSnackbar(error.message || "Failed to save overview", { variant: "error" })
        }
    }
}
